

<div *ngIf="daysLeft>0">
<div class="text-center text-danger pen30 font-italic"> 
 {{daysLeft}} - days left for exam</div>
</div>


<div class="text-right font-weight-bold text-danger"> Time & tide wait for none!</div>
